var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscountMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b52025",
    d: "M16 2.7L20.3 0l2.3 4.5 5.1-.2-.2 5.1 4.5 2.3-2.7 4.3 2.7 4.3-4.5 2.3.2 5.1-5.1-.2-2.3 4.5-4.3-2.7-4.3 2.7-2.3-4.5-5.1.2.2-5.1L0 20.3 2.7 16 0 11.7l4.5-2.3-.2-5.1 5.1.2L11.7 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 16.3c-.6-.8-.9-1.9-.9-3.4s.3-2.6.9-3.4C9 8.7 9.9 8.4 11 8.4s2 .4 2.6 1.1c.6.8.9 1.9.9 3.4s-.3 2.6-.9 3.4c-.6.7-1.5 1.1-2.6 1.1s-2-.4-2.6-1.1zm4.1-.9c.3-.5.5-1.4.5-2.5s-.2-2-.5-2.5-.8-.8-1.5-.8-1.2.3-1.5.8c-.4.5-.5 1.3-.5 2.5s.2 2 .5 2.5.8.8 1.5.8 1.2-.3 1.5-.8zm-.5 8.3c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s0-.3.1-.5l8-13.9c.2-.3.4-.5.7-.5.2 0 .3.1.5.2.1.1.2.3.2.5s0 .3-.1.5l-8.1 13.9c-.1.4-.4.5-.6.5zm6.5-1.3c-.6-.8-.9-1.9-.9-3.4s.3-2.6.9-3.4c.6-.8 1.5-1.1 2.6-1.1s2 .4 2.6 1.1c.6.8.9 1.9.9 3.4s-.3 2.6-.9 3.4-1.5 1.1-2.6 1.1-2-.4-2.6-1.1zm4.2-.9c.3-.5.5-1.4.5-2.5s-.2-2-.5-2.5-.8-.8-1.5-.8-1.2.3-1.5.8c-.3.5-.5 1.4-.5 2.5s.2 2 .5 2.5.8.8 1.5.8c.6 0 1.1-.3 1.5-.8z",
    fill: "#fff"
  })));
}

export default SvgDiscountMedium;